export const MAIN_TRACK_ID = 'main';
